"use strict";
/*
 * Created on 13.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowOverviewDTOConverter.
 * @author Tomáš Leity
 */


var WindowOverviewDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowOverviewDTOConverter, _DataObjectConverter_);

  function WindowOverviewDTOConverter() {
    _classCallCheck(this, WindowOverviewDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewDTOConverter).apply(this, arguments));
  }

  return WindowOverviewDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowOverviewDTOConverter = WindowOverviewDTOConverter;